import { siteHeaderActionsEn, siteNavItemsEn } from "@/app/content-en";
import { SearchExperience } from "@/app/pages/SearchExperience";

export default function EnglishSearchPage() {
  return (
    <SearchExperience
      locale="en"
      homeHref="/en/"
      searchPath="/en/search/"
      navItems={siteNavItemsEn}
      actionItems={siteHeaderActionsEn}
    />
  );
}
